<template lang="pug">
  div.wrap-module-application.py30
    div.wrap-title.block.mb40
      div.f.fc
        div.logo.mb4
          img(src="/img/hcc_logo.svg")
      span.fz12.bold.block.text-center.mb24 Healthcare Catalyst College 入学申込フォーム
    div.mb20
      div.f.fc.mb14
        ItemMediaUploader(
          v-if="existingImg"
          :imgId="docId"
          :existingImg="existingImg"
          ref="mediaUploader")
      span.fz12.text-center.block 正面向きの顔写真をご登録ください
    v-text-field(label="お名前" placeholder="山田太郎" v-model="name"
      color="#fff" dark)
    v-text-field(label="フリガナ" placeholder="ヤマダタロウ" v-model="furigana"
      color="#fff" dark)
    v-radio-group(v-model="sex" color="#008594" dark)
      span.label.block.fz12.mb4 性別
      div.f.fm.flex-wrap
        v-radio(v-for="item in ['男性', '女性', 'その他']"
          :label="item"
          :value="item"
          color="#008594").mr8.mb8
    div.wrap-birthday.mt12.mb32
      span.label.block.fz12.mb4 生年月日
      div.f.fm
        div.selection.mr8
          select(v-model="birthday.year").fz16.mr2
            option(v-for="item in yearSelection") {{item}}
          span.fz16 年
        div.selection.mr8
          select(v-model="birthday.month").fz16.mr2
            option(v-for="item in monthSelection") {{item}}
          span.fz16 月
        div.selection
          select(v-model="birthday.day").fz16.mr2
            option(v-for="item in daySelection") {{item}}
          span.fz16 日
    v-text-field(label="Email" placeholder="address@example.com"
      v-model="email"
      color="#fff" dark)
    v-text-field(label="電話番号" placeholder="08012345678"
      v-model="phoneNum"
      color="#fff" dark)
    v-text-field(label="郵便番号" placeholder="123-4567"
      v-model="postCode"
      color="#fff" dark)
    v-text-field(label="住所" placeholder="東京都新宿区1-2-3 EXビル 201号"
      v-model="address"
      color="#fff" dark).mb32
    //- div.wrap-occupation.mt24.mb32
    //-   span.label.block.fz12.mb4 職種
    //-   div
    //-     v-checkbox(v-for="item in ['選択肢１', '選択肢２', '選択肢3', 'その他']"
    //-       v-model="occupation"
    //-       :label="item"
    //-       :value="item"
    //-       color="#008594" dark).pr12
    //-   v-text-field(v-if="occupation.includes('その他')"
    //-     label="その他の職種名" placeholder="職種名を入力"
    //-     v-model="occupationOther"
    //-     color="#fff" dark).mt8
    //- div.wrap-reason.mb32
    //-   span.label.block.fz12.mb4 受講理由
    //-   div
    //-     v-checkbox(v-for="item in ['選択肢１', '選択肢２', '選択肢3', 'その他']"
    //-       v-model="reason"
    //-       :label="item"
    //-       :value="item"
    //-       color="#008594" dark).pr12
    //-   v-text-field(v-if="reason.includes('その他')"
    //-     label="その他の受講理由" placeholder="受講理由を入力"
    //-     v-model="reasonOther"
    //-     color="#008594" dark).mt8
    //- div.wrap-channel.mb32
    //-   span.label.block.fz12.mb4 何でHCCを知りましたか？（アンケート）
    //-   div
    //-     v-checkbox(v-for="item in ['選択肢１', '選択肢２', '選択肢3', 'その他']"
    //-       v-model="channel"
    //-       :label="item"
    //-       :value="item"
    //-       color="#008594" dark).pr12
    //-   v-text-field(v-if="channel.includes('その他')"
    //-     label="その他" placeholder="自由記述"
    //-     v-model="channelOther"
    //-     color="#008594" dark).mt8
    //- div.wrap-partner-id.mb32
    //-   v-text-field(label="招待コード" placeholder="招待コードをお持ちの方は入力"
    //-     v-model="partnerId"
    //-     hint="すでに招待コードが記入されている場合はこのまま送信してください"
    //-     color="#fff" dark).mt8
    v-btn.next-button(@click="submit" width="100%" color="#008594" dark).mb24 送信
    div.wrap-sign-out
      span(@click="logout").sign-out.block.text-center.fz14.cursor-pointer サインアウト
</template>

<style lang="scss" scoped>
.wrap-module-application {
  width: 93%;
  max-width: 420px;
  margin: 0 auto;
  span, select, option {
    color: #fff;
  }
  .wrap-title {
    .logo {
      width: 240px;
    }
  }
  .selection {
    border-bottom: solid #999 0.8px;
    select {
      outline: none;
    }
  }
  .next-button {
    color: white;
    background-color: #2a2a2a;
    margin: 0;
    width: 100%;
    height: 48px;
    border-radius: 4px;
  }
}
</style>

<style lang="scss">
.wrap-module-application {
  .v-input--selection-controls {
    margin: 0 !important;
    .v-input__slot {
      margin-bottom: 4px !important;
    }
    .v-messages {
      display: none !important;
    }
  }
  .v-label {
    color: #fff !important;
  }
}
</style>

<script>
import db, { firebase } from '@/components/utils/firebase'
import { appConfig } from '@/components/utils/appConfig'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemMediaUploader from '@/components/item/ItemMediaUploader.vue'
import { requests } from '../utils/requests'

export default {
  components: {
    ItemMediaUploader
  },
  data () {
    return {
      user: null,
      showModal: true,

      existingImg: '',
      docId: '',

      name: '',
      furigana: '',
      sex: '男性',
      birthday: {
        year: 1990,
        month: 1,
        day: 1
      },
      email: '',
      phoneNum: '',
      postCode: '',
      address: '',
      // occupation: [],
      // occupationOther: '',
      // reason: [],
      // reasonOther: '',
      // channel: [],
      // channelOther: '',
      partnerId: ''
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    appConfig: function() {
      return appConfig
    },
    yearSelection () {
      const start = 1920
      let result = []
      for (let i = 0; i < 100; i++) {
        result.push(start + i)
      }
      return result
    },
    monthSelection () {
      const start = 1
      let result = []
      for (let i = 0; i < 12; i++) {
        result.push(start + i)
      }
      return result
    },
    daySelection () {
      const start = 1
      let result = []
      for (let i = 0; i < 31; i++) {
        result.push(start + i)
      }
      return result
    },
    urlParams() {
      let result
      if (this.$route.query) {
        result = '?'
        for (const [key, value] of Object.entries(this.$route.query)) {
          result = result + `&${key}=${value}`
        }
        result = result.replace('&', '') // はじめの&だけ取り除く
      } else {
        result = ''
      }
      return result
    }
  },
  async created () {
    this.user = await db.collection('USERS')
      .doc(this.uid)
      .get()
      .then(d => d.data())
    
    // this.name = this.user.name
    this.email = await firebase.auth().currentUser.email
    this.existingImg = '/img/no-user-default.png' // this.user.iconURL
    this.docId = this.uid
    if (this.user.partnerId) this.partnerId = this.user.partnerId
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    logout() {
      this.signOut()
      setTimeout(this.toSignInPage, 400)
    },
    toSignInPage() {
      this.$router.push('/sign-in')
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    async submit () {
      if (!this.name
      || !this.furigana
      || !this.email
      || !this.phoneNum
      || !this.postCode
      || !this.address
      // || this.occupation === []
      // || (this.occupationOther === '' && this.occupation.includes('その他'))
      // || this.reason === []
      // || (this.reasonOther === '' && this.reason.includes('その他'))
      // || !this.channel
      // || (this.channelOther === '' && this.channelOther.includes('その他'))) {
      ) {
        alert('必要事項を全て記入してください')
        return
      }

      if (this.$refs.mediaUploader.uploadedImage === '/img/no-user-default.png') {
        alert('顔写真をアップロードしてください')
        return
      }

      const letSubmit = confirm('入学申込フォームを送信しますか？')
      if (!letSubmit) return

      let updateProps = { 
        name: this.name,
        iconURL: this.$refs.mediaUploader.uploadedImage
      }
      // if (this.partnerId) {
      //   updateProps.partnerId = this.partnerId
      // }
      await db.collection('USERS')
        .doc(this.uid)
        .update(updateProps)

      const application = {
        name: this.name,
        furigana: this.furigana,
        sex: this.sex,
        birthday: this.birthday,
        email: this.email,
        phoneNum: this.phoneNum,
        postCode: this.postCode,
        address: this.address,
        // occupation: this.occupation,
        // occupationOther: this.occupationOther,
        // reason: this.reason,
        // reasonOther: this.reasonOther,
        // channel: this.channel,
        // channelOther: this.channelOther,
        createdAt: new Date(),
        author: this.uid
      }
      
      await db.collection('USERS')
        .doc(this.uid)
        .collection('SECRETS')
        .doc('application')
        .set(application)

      alert('送信しました')

      if (this.partnerId) {
        const result = await requests.checkValidPartnerId()
          .catch(console.error);
        console.log({result})
        if (result) {
          const path = this.urlParams ? `/application-survey${this.urlParams}` : '/application-survey'
          this.$router.push(path)
          return;
        }
      }

      const path = this.urlParams ? `/payment${this.urlParams}` : '/payment'
      this.$router.push(path)
    }
  }
}
</script>
